import { loadFullscreenTooltip, setFullscreenTooltip } from "@/common/utils/storage";
import { useState, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useMediaQuery } from "usehooks-ts";
import { TABLET_WIDTH } from "@/common/utils/device";

interface IUseFsTooltip {
  position: number;
  isVideoVisible: boolean;
}

export const useFsTooltip = ({
  isVideoVisible,
  position
}: IUseFsTooltip) => {
  const [isCloseTooltip, setCloseTooltip] = useState<boolean>(!!loadFullscreenTooltip());
  const location = useLocation();
  const isMobile = useMediaQuery(`(max-width: ${TABLET_WIDTH}px)`);

  const isOnTagNichePages = useMemo(() =>
    location.pathname.includes("/niche") || location.pathname.includes("/gifs/"),
  [location.pathname]);

  const isShowFsTooltip = useMemo(
    () => position === 2 && isOnTagNichePages && !isCloseTooltip && isVideoVisible && isMobile,
    [position, isOnTagNichePages, isCloseTooltip, isVideoVisible, isMobile]
  );

  const onDismissFsTooltip = (forceClose: boolean) => {
    if (forceClose) {
      setCloseTooltip(true);
      return;
    }

    setFullscreenTooltip(true);
    setCloseTooltip(true);
  };

  return {
    isShowFsTooltip,
    onDismissFsTooltip,
  };
};
